import React, { useState } from 'react';
import { FadeIn, Section } from './ui';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el producto después de comprar?',
    a: 'Al instante. Después de confirmar el pago recibes un email con el link de descarga de todos los PDFs. No necesitas esperar nada. En 2 minutos ya tienes el sistema completo en tu celular o computadora.'
  }, {
    q: '¿Sirve para cualquier nivel de secundaria?',
    a: 'Sí. Los 6 tomos incluyen ejemplos y plantillas para todos los años de secundaria (1° a 6°) y cubren todos los bloques de contenido: álgebra, geometría, estadística, probabilidad y funciones.'
  }, {
    q: '¿Es un PDF o tengo acceso a una plataforma?',
    a: 'Son PDFs descargables. Los guardas en tu celular, tablet o computadora y los tienes disponibles sin conexión a internet, para siempre. Sin contraseñas, sin plataformas que se caen, sin suscripciones.'
  }, {
    q: '¿Funciona si ya tengo años de experiencia dando clases?',
    a: "Especialmente para docentes con experiencia. No es un manual de 'cómo dar clases'. Es un sistema de ejecución para docentes que ya saben lo que hacen pero quieren dejar de improvisar y sistematizarlo. La mayoría de los que lo compran tienen entre 5 y 15 años de experiencia."
  }, {
    q: '¿Qué diferencia hay entre el Sistema Base y el Elite Bundle?',
    a: 'El Sistema Base resuelve todo lo que pasa dentro del aula: apertura, guías, pizarrón, evaluación, consultas y cierre. El Elite Bundle agrega los 2 módulos que resuelven lo que pasa fuera del aula: los conflictos con familias (Diplomacia de Hierro) y el posicionamiento institucional (Marca Personal). Si quieres el sistema completo, el Elite Bundle es la decisión obvia por solo USD 6,00 más.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes 7 días de garantía total. Si no estás satisfecho por cualquier motivo, te devolvemos el 100% del dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section variant="light" data-id="element-139">
      <FadeIn data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-10 text-center" data-id="element-141">
          Preguntas frecuentes
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-142">
        {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-143">
            <div className={`bg-white border rounded-xl overflow-hidden transition-colors duration-300 shadow-sm ${openIndex === i ? 'border-brand-green' : 'border-gray-200'}`} data-id="element-144">
              <button className="w-full text-left p-5 flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-145">
                <span className="font-bold text-gray-900 pr-4" data-id="element-146">{faq.q}</span>
                <ChevronDown className={`text-brand-green shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-147" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-148">
                <p className="p-5 pt-0 text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-149">
                  {faq.a}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}